export const makeid = () => {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < 5; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
export const DynamicComponentsDefaultproperties = {
  Chart: {
    chartType: "Select",
    chartData: {
      data: [
        ["labelTitle", "DatasetTitle1", "DatasetTitle2"],
        ["label", 5, 12],
      ],
      options: {
        title: "Your chart",
        titleTextStyle: {
          fontSize: 20,
        },
        isStacked: false,
        isColumn: false,
        colors: [
          {
            color: "#ADD8E6",
          },
          {
            color: "#b0120a",
          },
        ],
        legend: {
          position: "bottom",
          alignment: "center",
          textStyle: {
            color: "#000",
            fontSize: 16,
          },
        },
        hAxis: {
          title: "Total Population",
        },
        vAxis: {
          title: "City",
        },
      },
    },
  },
  CustomForm: {
    id: "",
  },
}
export const mainMenuList = [
  {
    name: "Pages",
    id: 0,
    icon: "FlipToFront",
  },
  {
    name: "Elements",
    id: 1,
    icon: "OpenInBrowser",
  },
  {
    name: "Element Tree",
    id: 2,
    icon: "AccountTreeOutlined",
  },
];

// all component panel list
export const ComponentsLists = [
  {
    catagerie: "layouts",
    list: [
      {
        name: "Container",
      },
      {
        name: "Col",
      },
      {
        name: "Row",
      },
      {
        name: "Hidden",
      },
      {
        name: "Divider",
      },
      { name: "Paper" },
      {
        name: "Card",
      },
      { name: "CardActions" },
      { name: "CardContent" },
      { name: "CardHeader" },
      { name: "CardMedia" },
      { name: "ButtonGroup" },
      { name: "List" },
      { name: "ListItem" },
      { name: "Image" },
      { name: "Dropdown" },
      { name: "Tab" },
      { name: "Collapse" },
      { name: "Tabpanel" },
    ],
  },
  {
    catagerie: "inputs",
    list: [
      {
        name: "Button",
      },
      {
        name: "Select",
      },
      {
        name: "Link",
      },
      {
        name: "TextInput",
      },
      {
        name: "TextArea",
      },
      { name: "Switch" },
      { name: "Radio" },
      {
        name: "Checkbox",
      },
      { name: "MultiSelect" },
      { name: "RangePicker" },
      { name: "Upload" },
      // { name: "TopSelect" },
      { name: "DateTimepicker" },
    ],
  },
  {
    catagerie: "Data display",
    list: [
      {
        name: "Text",
      },
      {
        name: "H1",
      },
      {
        name: "H2",
      },
      {
        name: "H6",
      },
      {
        name: "Badge",
      },
      { name: "Avatar" },
      { name: "Chip" },
      { name: "Carousel" },
    ],
  },
  {
    catagerie: "Feedbacks",
    list: [
      {
        name: "Alert",
      },
      { name: "CircularProgress" },
      { name: "Drawer" },
      { name: "Modal" },
      { name: "DialogTitle" },
      { name: "DialogActions" },
      { name: "DialogContent" },
      { name: "TopHeader" },
      { name: "Snackbar" },
      { name: "SideMenu" },
      { name: "BorderLinearProgress" },
      { name: "Table" },
    ],
  },
  {
    catagerie: "New Component's",
    list: [
      {
        name: "TapSelect",
      },
      {
        name: "LocationSearch",
      },
      {
        name: "AutoSuggestion",
      },
      {
        name: "BackgroundImage",
      },
      {
        name: "OtpInput",
      },
      {
        name: "WeekCalendar",
      },
      {
        name: "Icons",
      },
      {
        name: "Div",
      },
      {
        name: "Translate",
      },
      {
        name: "MobileNumberWithCode",
      },
      {
        name: "Form",
      },
      {
        name: "CustomForm",
      },
      {
        name: "Chart",
      },
      {
        name: "MockUI",
      },
      {
        name: "CustomCode",
      },
      {
        name: "QRscan",
      },
      // {
      //   name: "AinqaFlex",
      // },
      // {
      //   name: "Div"
      // },
      // {
      //   name: "MobileNumberWithCode"
      // }
    ],
  },
  {
    catagerie: "function library",
    list: [
      {
        name: "IdmPanel",
      },
    ],
  },
];
export const DynamicComponentsList = [
  { name: "Chart" },
  { name: "CustomForm" },
  { name: "MockUI" },
  { name: "CustomCode" },
];
export const eleAtrribute = {};
export const templates = [
  {
    name: "Login 1",
    type: "screen",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-27-at-2.56.21-AM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",

      attr: null,
      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",

          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              attr: null,
              child: [
                {
                  type: "component",
                  component: "Avatar",
                  component_type: "qdm",
                  name: "Avatar",

                  attr: null,
                  properties: {
                    variant: "circle",
                    letter: "Avatar",
                    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTaYJedNSI9VRBJHtu9Ap70kCbn_phlUrz6GaStb9XOsriIg7nV8PTwEUMNR3MNog_MKUM&usqp=CAU",
                    alt: "Image",
                  },
                  inlineStyles: {
                    backgroundColor: "#fff",
                    borderRadius: "0px",
                    margin: "0px",
                    height: "40px",
                    width: "120px",
                  },
                },
              ],
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            padding: "20px",
          },
        },
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",

          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "6",
                xs: 12,
                md: "6",
                sm: 12,
              },
              inlineStyles: {
                textAlign: "center",
              },
              child: [
                {
                  type: "component",
                  component: "Row",
                  component_type: "qdm",
                  name: "Row",

                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Avatar",
                      component_type: "qdm",
                      name: "Avatar",

                      attr: null,
                      properties: {
                        variant: "circle",
                        letter: "Avatar",
                        src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTaYJedNSI9VRBJHtu9Ap70kCbn_phlUrz6GaStb9XOsriIg7nV8PTwEUMNR3MNog_MKUM&usqp=CAU",
                        alt: "Image",
                      },
                      inlineStyles: {
                        margin: "auto",
                        borderRadius: "0px",
                        backgroundColor: "#fff",
                        width: "312px",
                        height: "312px",
                      },
                    },
                  ],
                  properties: {
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    spacing: 2,
                  },
                  inlineStyles: {
                    display: "",
                  },
                },
                {
                  type: "component",
                  component: "Row",
                  component_type: "qdm",
                  name: "Row",

                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",

                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "Text",
                          component_type: "qdm",
                          name: "Text",

                          attr: null,
                          properties: {
                            name: "Leveraging the power of a connected community, towards the empowerment of health, wellness and care for individuals and families.",
                          },
                          inlineStyles: {
                            textAlign: "center",
                          },
                        },
                        {
                          type: "component",
                          component: "H6",
                          component_type: "qdm",
                          name: "H6",

                          attr: null,
                          properties: {
                            name: "Description content",
                          },
                          inlineStyles: {
                            fontSize: "1rem",
                            color: "#363a57",
                            marginTop: "14px",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        textAlign: "center",
                      },
                    },
                  ],
                  properties: {
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    spacing: 2,
                  },
                  inlineStyles: {
                    padding: "24px",
                  },
                },
              ],
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "6",
                xs: 12,
                md: "6",
                sm: 12,
              },
              inlineStyles: {
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              },
              child: [
                {
                  type: "component",
                  component: "Row",
                  component_type: "qdm",
                  name: "Row",

                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",

                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "H6",
                          component_type: "qdm",
                          name: "H6",

                          attr: null,
                          properties: {
                            name: "Welcome Back",
                          },
                          inlineStyles: {
                            color: "#363a57",
                            fontSize: "1.5rem",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        textAlign: "center",
                      },
                    },
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",

                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "Text",
                          component_type: "qdm",
                          name: "Text",

                          attr: null,
                          properties: {
                            name: "Enter your credentials to proceed",
                          },
                          inlineStyles: {
                            color: "#9297a5",
                            fontSize: "1rem",
                            marginBottom: "",
                            paddingBottom: "",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        textAlign: "center",
                        marginBottom: "20px",
                      },
                    },
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",

                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "TextInput",
                          component_type: "qdm",
                          name: "TextInput",

                          attr: null,
                          properties: {
                            type: "email",
                            name: "text",
                            size: "medium",
                            variant: "outlined",
                            helperTextType: "error",
                            label: "Email Address",
                            autoFocus: false,
                          },
                          inlineStyles: {},
                        },
                        {
                          type: "component",
                          component: "TextInput",
                          component_type: "qdm",
                          name: "TextInput",

                          attr: null,
                          properties: {
                            type: "text",
                            name: "text",
                            size: "medium",
                            variant: "outlined",
                            helperTextType: "error",
                            label: "Password",
                            autoFocus: false,
                          },
                          inlineStyles: {},
                        },
                        {
                          type: "component",
                          component: "Button",
                          component_type: "qdm",
                          name: "Button",

                          attr: null,
                          properties: {
                            type: "submit",
                            color: "secondary",
                            size: "medium",
                            variant: "outlined",
                            name: "Sign In",
                          },
                          inlineStyles: {
                            width: "100%",
                            backgroundColor: "#009490",
                            borderColor: "#009490",
                            borderRadius: "8px",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: "12",
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {},
                    },
                  ],
                  properties: {
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    spacing: 2,
                  },
                  inlineStyles: {
                    textAlign: "",
                    padding: "40px",
                  },
                },
              ],
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: "0",
          },
          inlineStyles: {
            padding: "20px",
          },
        },
      ],
      properties: {
        name: "container",
        fluid: false,
      },
      inlineStyles: {
        backgroundColor: "#fff",
        height: "100vh",
      },
    },
  },
  {
    name: "Login 2",
    type: "screen",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-27-at-2.59.28-AM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",

      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        height: "100vh",
        backgroundColor: "#ebebeb",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      child: [
        {
          type: "component",
          component: "Card",
          component_type: "qdm",
          name: "Card",

          properties: {
            children: "Card",
          },
          inlineStyles: {
            width: "300px",
          },
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "Row",
                  component_type: "qdm",
                  name: "Row",

                  child: [
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",

                      child: [
                        {
                          type: "component",
                          component: "Avatar",
                          component_type: "qdm",
                          name: "Avatar",

                          properties: {
                            variant: "circle",
                            letter: "Avatar",
                            src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTaYJedNSI9VRBJHtu9Ap70kCbn_phlUrz6GaStb9XOsriIg7nV8PTwEUMNR3MNog_MKUM&usqp=CAU",
                            alt: "Image",
                          },
                          inlineStyles: {
                            backgroundColor: "#fff",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    },
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",

                      child: [
                        {
                          type: "component",
                          component: "Text",
                          component_type: "qdm",
                          name: "Text",

                          properties: {
                            name: "Project Name",
                          },
                          inlineStyles: {
                            fontSize: "16px",
                          },
                          customAttr: ["children"],
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    },
                  ],
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "flex-start",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {},
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "TextInput",
                  component_type: "qdm",
                  name: "TextInput",

                  properties: {
                    type: "text",
                    name: "text",
                    size: "medium",
                    variant: "outlined",
                    helperTextType: "error",
                    label: "User name ",
                    autoFocus: false,
                    autoComplete: "off",
                  },
                  inlineStyles: {},
                },
                {
                  type: "component",
                  component: "TextInput",
                  component_type: "qdm",
                  name: "TextInput",

                  properties: {
                    type: "text",
                    name: "text",
                    size: "medium",
                    variant: "outlined",
                    helperTextType: "error",
                    label: "Password",
                    autoFocus: false,
                    autoComplete: "off",
                  },
                  inlineStyles: {},
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                marginTop: "14px",
              },
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "Button",
                  component_type: "qdm",
                  name: "Button",

                  properties: {
                    type: "button",
                    color: "primary",
                    size: "medium",
                    variant: "outlined",
                    name: "Login",
                  },
                  inlineStyles: {
                    width: "100%",
                    backgroundColor: "#45bf84",
                    borderColor: "#45bf84",
                  },
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                marginBottom: "20px",
              },
            },
          ],
        },
      ],
    },
  },
  {
    name: "Layout 1",
    type: "layout",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-26-at-5.26.43-PM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",

      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",

          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "Text",
                  component_type: "qdm",
                  name: "Text",

                  properties: {
                    name: "Header",
                  },
                  inlineStyles: {
                    fontSize: "20px",
                    fontWeight: "500",
                    color: "#fff",
                  },
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#007aff",
                height: "55px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              },
            },
          ],
        },
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",

          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "4",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#ffffff",
                color: "",
                padding: "20px",
              },
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",

                  properties: {
                    name: "Side bar",
                  },
                  inlineStyles: {
                    color: "#000",
                  },
                },
              ],
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "8",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#e8e8e8",
                padding: "20px",
              },
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",

                  properties: {
                    name: "Main content",
                  },
                  inlineStyles: {},
                },
              ],
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            height: "100vh",
          },
        },
      ],
      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        padding: "0px",
      },
    },
  },
  {
    name: "Layout 2",
    type: "layout",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-26-at-5.25.56-PM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",

      attr: null,
      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",

          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              attr: null,
              child: [
                {
                  type: "component",
                  component: "Text",
                  component_type: "qdm",
                  name: "Text",

                  attr: null,
                  properties: {
                    name: "Header",
                  },
                  inlineStyles: {
                    fontSize: "20px",
                    fontWeight: "500",
                  },
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                height: "55px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              },
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            backgroundColor: "#ffffff",
            height: "",
          },
        },
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",

          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              attr: null,
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",

                  attr: null,
                  properties: {
                    name: "Main Content ",
                  },
                  inlineStyles: {},
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                padding: "20px",
              },
            },
          ],
        },
      ],
      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        backgroundColor: "#e8e8e8",
        height: "100vh",
        padding: "0px",
      },
    },
  },
  {
    name: "Layout 3",
    type: "layout",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-26-at-5.29.02-PM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",

      attr: null,
      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",

          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              attr: null,
              child: [
                {
                  type: "component",
                  component: "Text",
                  component_type: "qdm",
                  name: "Text",

                  attr: null,
                  properties: {
                    name: "Header",
                  },
                  inlineStyles: {
                    fontSize: "24px",
                    fontWeight: "500",
                  },
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#ffffff",
                height: "60px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              },
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            height: "",
          },
        },
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",

          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "1",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#3A4B58",
                padding: "10px",
              },
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",

                  attr: null,
                  properties: {
                    name: "Menu",
                  },
                  inlineStyles: {
                    color: "#ffffff",
                  },
                },
              ],
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "11",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#f2f2f2",
                padding: "20px",
              },
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",

                  attr: null,
                  properties: {
                    name: "Content",
                  },
                  inlineStyles: {},
                },
              ],
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            height: "100vh",
          },
        },
      ],
      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        padding: "0px",
        backgroundColor: "#ffffff",
      },
    },
  },
  {
    name: "Layout 4",
    type: "layout",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-26-at-5.27.56-PM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",

      attr: null,
      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        backgroundColor: "#ffffff",
        padding: "0px",
      },
      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",

          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                height: "60px",
                backgroundColor: "#3a4b58",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                color: "#ffffff",
              },
              child: [
                {
                  type: "component",
                  component: "Text",
                  component_type: "qdm",
                  name: "Text",

                  attr: null,
                  properties: {
                    name: "Header",
                  },
                  inlineStyles: {
                    color: "",
                    fontSize: "22px",
                    fontWeight: "500",
                  },
                },
              ],
            },
          ],
        },
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",

          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "3",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {},
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",

                  attr: null,
                  properties: {
                    name: "Side menu",
                  },
                  inlineStyles: {
                    padding: "10px",
                  },
                },
              ],
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "6",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#f5f5f5",
                padding: "20px",
              },
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",

                  attr: null,
                  properties: {
                    name: "Content",
                  },
                  inlineStyles: {},
                },
              ],
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "3",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {},
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",

                  attr: null,
                  properties: {
                    name: "Right Content",
                  },
                  inlineStyles: {
                    padding: "10px",
                  },
                },
              ],
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            height: "100vh",
          },
        },
      ],
    },
  },
  {
    name: "Layout 5",
    type: "layout",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-26-at-5.27.26-PM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",

      attr: null,
      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",

          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "1",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#3A4B58",
                padding: "10px",
              },
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",

                  attr: null,
                  properties: {
                    name: "Menu",
                  },
                  inlineStyles: {
                    color: "#ffffff",
                  },
                },
              ],
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "11",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#f2f2f2",
                padding: "0px",
              },
              child: [
                {
                  type: "component",
                  component: "Row",
                  component_type: "qdm",
                  name: "Row",

                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",

                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "Text",
                          component_type: "qdm",
                          name: "Text",

                          attr: null,
                          properties: {
                            name: "Header",
                          },
                          inlineStyles: {
                            fontSize: "24px",
                            fontWeight: "500",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        backgroundColor: "#ffffff",
                        height: "60px",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        padding: "",
                      },
                    },
                  ],
                  properties: {
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    spacing: 2,
                  },
                  inlineStyles: {
                    height: "",
                  },
                },
                {
                  type: "component",
                  component: "Row",
                  component_type: "qdm",
                  name: "Row",

                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",

                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "H6",
                          component_type: "qdm",
                          name: "H6",

                          attr: null,
                          properties: {
                            name: "Content",
                          },
                          inlineStyles: {},
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        padding: "20px",
                      },
                    },
                  ],
                },
              ],
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            height: "100vh",
          },
        },
      ],
      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        padding: "0px",
        backgroundColor: "#ffffff",
      },
    },
  },
  {
    name: "Confirmation Template",
    type: "layout",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-29-at-10.54.42-PM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",

      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        height: "100vh",
        backgroundColor: "#ebebeb",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      child: [
        {
          type: "component",
          component: "Card",
          component_type: "qdm",
          name: "Card",

          properties: {
            children: "Card",
          },
          inlineStyles: {
            width: "500px",
            padding: "20px",
          },
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "Row",
                  component_type: "qdm",
                  name: "Row",

                  child: [
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",

                      child: [
                        {
                          type: "component",
                          component: "Avatar",
                          component_type: "qdm",
                          name: "Avatar",

                          properties: {
                            variant: "circle",
                            letter: "Avatar",
                            src: "data:image/png;base64,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",
                            alt: "Image",
                          },
                          inlineStyles: {
                            backgroundColor: "#fff",
                            width: "70px",
                            height: "70px",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    },
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",

                      child: [
                        {
                          type: "component",
                          component: "H6",
                          component_type: "qdm",
                          name: "H6",

                          properties: {
                            name: "Success",
                          },
                          inlineStyles: {
                            fontSize: "24px",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    },
                  ],
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "flex-start",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {},
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "Divider",
                  component_type: "qdm",
                  name: "Divider",

                  properties: {
                    textWidth: 50,
                    textColor: "#000",
                    borderColor: "lightgray",
                    borderWidth: 1,
                    orientation: "horizontal",
                    variant: "fullWidth",
                  },
                  inlineStyles: {},
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                marginTop: "14px",
              },
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "Text",
                  component_type: "qdm",
                  name: "Text",

                  properties: {
                    name: "Check your emil for a confirmation. We'll see you soon",
                  },
                  inlineStyles: {
                    textAlign: "",
                    fontSize: "14px",
                  },
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                marginBottom: "20px",
                textAlign: "center",
              },
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "Button",
                  component_type: "qdm",
                  name: "Button",

                  properties: {
                    type: "button",
                    variant: "outlined",
                    name: "Ok",
                  },
                  inlineStyles: {
                    width: "100px",
                    backgroundColor: "#63bc44",
                    borderColor: "#63bc44",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    fontSize: "20px",
                    fontWeight: "600",
                  },
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              },
            },
          ],
        },
      ],
    },
  },
  {
    name: "Demographic Data",
    type: "layout",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-29-at-10.31.45-PM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",

      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",

          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "Text",
                  component_type: "qdm",
                  name: "Text",

                  properties: {
                    name: "Demographic Data",
                  },
                  inlineStyles: {
                    fontSize: "20px",
                    fontWeight: "500",
                  },
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                height: "55px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              },
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            backgroundColor: "#ffffff",
            height: "",
          },
        },
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",

          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "Paper",
                  component_type: "qdm",
                  name: "Paper",

                  properties: {
                    children: "Paper",
                    variant: "elevation",
                    elevation: 1,
                  },
                  inlineStyles: {
                    backgroundColor: "#ffffff",
                    padding: "20px",
                    margin: "0px",
                  },
                  child: [
                    {
                      type: "component",
                      component: "Row",
                      component_type: "qdm",
                      name: "Row",

                      child: [
                        {
                          type: "component",
                          component: "Col",
                          component_type: "qdm",
                          name: "Col",

                          properties: {
                            name: "qdm-col-12",
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            textAlign: "left",
                            lg: "6",
                            xs: 12,
                            md: "6",
                            sm: 12,
                          },
                          inlineStyles: {
                            marginBottom: "20px",
                          },
                          child: [
                            {
                              type: "component",
                              component: "TextInput",
                              component_type: "qdm",
                              name: "TextInput",

                              properties: {
                                type: "text",
                                name: "text",
                                variant: "outlined",
                                helperTextType: "error",
                                label: "User Name",
                                autoFocus: false,
                                autoComplete: "off",
                                search: false,
                                borderColor: "#9b9b9b",
                                elevation: "0",
                                placeholder: "text field",
                                size: "medium",
                              },
                              inlineStyles: {
                                marginTop: "",
                              },
                            },
                          ],
                        },
                        {
                          type: "component",
                          component: "Col",
                          component_type: "qdm",
                          name: "Col",

                          properties: {
                            name: "Provider Gender",
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            textAlign: "left",
                            lg: "6",
                            xs: 12,
                            md: "6",
                            sm: 12,
                          },
                          inlineStyles: {
                            marginBottom: "20px",
                          },
                          child: [
                            {
                              type: "component",
                              component: "TapSelect",
                              component_type: "qdm",
                              name: "TapSelect",

                              properties: {
                                type: "single",
                                fullWidth: false,
                                selectedBorderColor: "#1890ff",
                                selectedBackgroundColor: "#fff",
                                selectedTextColor: "#1890ff",
                                textSize: "small",
                                iconHeight: 20,
                                iconWidth: 20,
                                textColor: "#000",
                                label: "Gender",
                                options: [
                                  {
                                    value: "Male",
                                    label: "Male",
                                  },
                                  {
                                    value: "Female",
                                    label: "Female",
                                  },
                                  {
                                    value: "Others",
                                    label: "Others",
                                  },
                                ],
                                iconPosition: "left",
                              },
                              inlineStyles: {},
                            },
                          ],
                        },
                        {
                          type: "component",
                          component: "Col",
                          component_type: "qdm",
                          name: "Col",

                          properties: {
                            name: "qdm-col-12",
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            textAlign: "left",
                            lg: "6",
                            xs: 12,
                            md: "6",
                            sm: 12,
                          },
                          inlineStyles: {
                            marginBottom: "20px",
                          },
                          child: [
                            {
                              type: "component",
                              component: "TextInput",
                              component_type: "qdm",
                              name: "TextInput",

                              properties: {
                                type: "text",
                                name: "text",
                                variant: "outlined",
                                helperTextType: "error",
                                label: "Email",
                                autoFocus: false,
                                autoComplete: "off",
                                search: false,
                                borderColor: "#9b9b9b",
                                elevation: "0",
                                placeholder: "text field",
                                size: "medium",
                              },
                              inlineStyles: {},
                            },
                          ],
                        },
                        {
                          type: "component",
                          component: "Col",
                          component_type: "qdm",
                          name: "Col",

                          properties: {
                            name: "qdm-col-12",
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            textAlign: "left",
                            lg: "6",
                            xs: 12,
                            md: "6",
                            sm: 12,
                          },
                          inlineStyles: {
                            marginBottom: "20px",
                          },
                          child: [
                            {
                              type: "component",
                              component: "TextInput",
                              component_type: "qdm",
                              name: "TextInput",

                              properties: {
                                type: "number",
                                name: "text",
                                variant: "outlined",
                                helperTextType: "error",
                                label: "Mobile Number",
                                autoFocus: false,
                                autoComplete: "off",
                                search: false,
                                borderColor: "#9b9b9b",
                                elevation: "0",
                                placeholder: "text field",
                                size: "medium",
                              },
                              inlineStyles: {},
                            },
                          ],
                        },
                        {
                          type: "component",
                          component: "Col",
                          component_type: "qdm",
                          name: "Col",

                          properties: {
                            name: "qdm-col-12",
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            textAlign: "left",
                            lg: "6",
                            xs: 12,
                            md: "6",
                            sm: 12,
                          },
                          inlineStyles: {
                            marginBottom: "20px",
                          },
                          child: [
                            {
                              type: "component",
                              component: "TextInput",
                              component_type: "qdm",
                              name: "TextInput",

                              properties: {
                                type: "text",
                                name: "text",
                                variant: "outlined",
                                helperTextType: "error",
                                label: "Address",
                                autoFocus: false,
                                autoComplete: "off",
                                search: false,
                                borderColor: "#9b9b9b",
                                elevation: "0",
                                placeholder: "text field",
                                size: "medium",
                              },
                              inlineStyles: {},
                            },
                          ],
                        },
                        {
                          type: "component",
                          component: "Col",
                          component_type: "qdm",
                          name: "Col",

                          child: [
                            {
                              type: "component",
                              component: "Button",
                              component_type: "qdm",
                              name: "Button",

                              properties: {
                                type: "button",
                                variant: "text",
                                name: "Cancel",
                              },
                              inlineStyles: {
                                margin: "5px",
                              },
                            },
                            {
                              type: "component",
                              component: "Button",
                              component_type: "qdm",
                              name: "Button",

                              properties: {
                                type: "button",
                                variant: "outlined",
                                name: "Add",
                              },
                              inlineStyles: {
                                margin: "5px",
                                width: "100px",
                              },
                            },
                          ],
                          properties: {
                            name: "qdm-col-12",
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            textAlign: "left",
                            lg: 12,
                            xs: 12,
                            md: 12,
                            sm: 12,
                          },
                          inlineStyles: {
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                padding: "24px",
                paddingTop: "40px",
              },
            },
          ],
        },
      ],
      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        backgroundColor: "#e8e8e8",
        height: "100vh",
        padding: "0px",
      },
    },
  },
  {
    name: "Listing Layout",
    type: "layout",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-27-at-3.17.24-AM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",

      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",

          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "6",
                xs: "6",
                md: "6",
                sm: "6",
              },
              inlineStyles: {
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              },
              child: [
                {
                  type: "component",
                  component: "Avatar",
                  component_type: "qdm",
                  name: "Avatar",

                  properties: {
                    variant: "circle",
                    letter: "Avatar",
                    src: "https://www.pinclipart.com/picdir/middle/544-5440422_back-arrow-icon-transparent-png-clipart-free-download.png",
                    alt: "Image",
                  },
                  inlineStyles: {
                    margin: "0px",
                    marginRight: "14px",
                    width: "20px",
                    height: "20px",
                    backgroundColor: "#f5f5f5",
                  },
                },
                {
                  type: "component",
                  component: "Text",
                  component_type: "qdm",
                  name: "Text",

                  properties: {
                    name: "Title",
                  },
                  inlineStyles: {
                    fontSize: "20px",
                    fontWeight: "500",
                  },
                },
              ],
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "6",
                xs: "6",
                md: "6",
                sm: "6",
              },
              inlineStyles: {
                textAlign: "right",
              },
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",

                  properties: {
                    name: "Profile name",
                  },
                  inlineStyles: {
                    fontSize: "14px",
                    fontWeight: "400",
                  },
                },
                {
                  type: "component",
                  component: "Text",
                  component_type: "qdm",
                  name: "Text",

                  properties: {
                    name: "Role",
                  },
                  inlineStyles: {
                    color: "#9297a5",
                  },
                },
              ],
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            padding: "10px",
            backgroundColor: "#f5f5f5",
            borderColor: "#e0e0e0d6",
            borderWidth: "1px",
            borderStyle: "solid",
            marginBottom: "",
          },
        },
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",

          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "Select",
                  component_type: "qdm",
                  name: "Select",

                  properties: {
                    disabled: false,
                    size: "medium",
                    helperTextType: "error",
                    label: "Search for provider Name",
                    variant: "outlined",
                  },
                  inlineStyles: {
                    width: "",
                  },
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "8",
                xs: 12,
                md: "8",
                sm: 12,
              },
              inlineStyles: {},
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "Button",
                  component_type: "qdm",
                  name: "Button",

                  properties: {
                    type: "button",
                    variant: "outlined",
                    name: "+ ADD BUTTON",
                    color: "primary",
                    size: "medium",
                  },
                  inlineStyles: {
                    backgroundColor: "",
                    borderColor: "",
                    borderRadius: "8px",
                    color: "#ffffff",
                  },
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "4",
                xs: 12,
                md: "4",
                sm: 12,
              },
              inlineStyles: {
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              },
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            paddingTop: "",
            padding: "14px",
          },
        },
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",

          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",

                  properties: {
                    name: "Titte",
                  },
                  inlineStyles: {},
                },
              ],
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "List",
                  component_type: "qdm",
                  name: "List",

                  properties: {
                    children: "List",
                  },
                  inlineStyles: {
                    backgroundColor: "#f5f4f5",
                  },
                  child: [
                    {
                      type: "component",
                      component: "ListItem",
                      component_type: "qdm",
                      name: "ListItem",

                      properties: {
                        title: "Vasan Dental Clinic",
                        description: "List Item Descaription",
                        profile: "L",
                        action: "Click",
                        marginVertical: 0,
                        marginHorizontal: 0,
                        paddingVertical: 8,
                        paddingHorizontal: 16,
                      },
                      inlineStyles: {
                        backgroundColor: "#fff",
                        marginBottom: "20px",
                        borderRadius: "6px",
                        paddingTop: "14px",
                        paddingBottom: "14px",
                      },
                      child: [
                        {
                          type: "component",
                          component: "Row",
                          component_type: "qdm",
                          name: "Row",

                          child: [
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",

                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "9",
                                xs: "12",
                                md: "9",
                                sm: "12",
                              },
                              inlineStyles: {
                                display: "inline-flex",
                                justifyContent: "",
                                alignItems: "",
                                padding: "0px",
                                paddingTop: "",
                                paddingLeft: "",
                                paddingBottom: "",
                                paddingRight: "",
                              },
                              child: [
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",

                                  child: [
                                    {
                                      type: "component",
                                      component: "Avatar",
                                      component_type: "qdm",
                                      name: "Avatar",

                                      properties: {
                                        variant: "circle",
                                        letter: "Avatar",
                                        src: "https://image.freepik.com/free-vector/healthcare-logo_10250-3453.jpg",
                                        alt: "Image",
                                      },
                                      inlineStyles: {
                                        margin: "0px",
                                        marginRight: "14px",
                                      },
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: 2,
                                  },
                                  inlineStyles: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "0px",
                                  },
                                },
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",

                                  child: [
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",

                                      child: [
                                        {
                                          type: "component",
                                          component: "Text",
                                          component_type: "qdm",
                                          name: "Text",

                                          properties: {
                                            name: "Vasan Dental Clinic",
                                          },
                                          inlineStyles: {
                                            marginRight: "10px",
                                            fontSize: "1rem",
                                          },
                                        },
                                        {
                                          type: "component",
                                          component: "Text",
                                          component_type: "qdm",
                                          name: "Text",

                                          properties: {
                                            name: "• ACTIVE",
                                          },
                                          inlineStyles: {
                                            color: "#31b198",
                                            fontWeight: "500",
                                            fontSize: "14px",
                                          },
                                        },
                                      ],
                                      properties: {
                                        name: "qdm-col-12",
                                        alignItems: "stretch",
                                        direction: "row",
                                        justify: "flex-start",
                                        textAlign: "left",
                                        lg: 12,
                                        xs: 12,
                                        md: 12,
                                        sm: 12,
                                      },
                                      inlineStyles: {
                                        padding: "0px",
                                        marginBottom: "10px",
                                      },
                                    },
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",

                                      child: [
                                        {
                                          type: "component",
                                          component: "Chip",
                                          component_type: "qdm",
                                          name: "Chip",

                                          properties: {
                                            variant: "circle",
                                            name: "Chip",
                                          },
                                          inlineStyles: {
                                            margin: "0px",
                                            padding: "",
                                            borderRadius: "4px",
                                            backgroundColor: "#f4f4f5",
                                            paddingTop: "2px",
                                            paddingBottom: "2px",
                                            paddingLeft: "10px",
                                            paddingRight: "10px",
                                            color: "#9297a5",
                                            fontSize: "14px",
                                            borderColor: "#f4f4f5",
                                          },
                                        },
                                      ],
                                      properties: {
                                        name: "qdm-col-12",
                                        alignItems: "stretch",
                                        direction: "row",
                                        justify: "flex-start",
                                        textAlign: "left",
                                        lg: 12,
                                        xs: 12,
                                        md: 12,
                                        sm: 12,
                                      },
                                      inlineStyles: {
                                        padding: "0px",
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",

                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "3",
                                xs: "12",
                                md: "3",
                                sm: "12",
                              },
                              inlineStyles: {
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              },
                              child: [
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",

                                  child: [
                                    {
                                      type: "component",
                                      component: "H6",
                                      component_type: "qdm",
                                      name: "H6",

                                      properties: {
                                        name: "1",
                                      },
                                      inlineStyles: {},
                                    },
                                    {
                                      type: "component",
                                      component: "Text",
                                      component_type: "qdm",
                                      name: "Text",

                                      properties: {
                                        name: "Branches",
                                      },
                                      inlineStyles: {
                                        color: "#9297a5",
                                      },
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: 2,
                                  },
                                  inlineStyles: {
                                    display: "block",
                                  },
                                },
                              ],
                            },
                          ],
                          properties: {
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            spacing: 2,
                          },
                          inlineStyles: {
                            width: "100%",
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            padding: "",
            paddingLeft: "14px",
            paddingRight: "14px",
          },
        },
      ],
      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        backgroundColor: "#F4F4F5",
        padding: "0px",
        height: "100vh",
      },
    },
  },
  {
    name: "Listing Card",
    type: "layout",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-27-at-3.45.11-AM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",

      attr: null,
      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",

          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "1",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#3A4B58",
                padding: "0px",
              },
              child: [
                {
                  type: "component",
                  component: "Div",
                  component_type: "qdm",
                  name: "Div",

                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Avatar",
                      component_type: "qdm",
                      name: "Avatar",

                      attr: null,
                      properties: {
                        variant: "rounded",
                        letter: "Avatar",
                        src: "https://i.pinimg.com/originals/72/a3/d9/72a3d9408d41335f39e9f014dc35cf44.jpg",
                        alt: "Image",
                      },
                      inlineStyles: {
                        width: "45px",
                        height: "45px",
                      },
                    },
                  ],
                  properties: {
                    className: "qdm",
                  },
                  inlineStyles: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "20px",
                    backgroundColor: "",
                  },
                },
                {
                  type: "component",
                  component: "Div",
                  component_type: "qdm",
                  name: "Div",

                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Icons",
                      component_type: "qdm",
                      name: "Icons",

                      attr: null,
                      properties: {
                        fontIcon: "area-chart",
                        ariaHidden: "true",
                        size: "small",
                      },
                      inlineStyles: {
                        fontSize: "26px",
                        color: "#ffffff",
                      },
                    },
                  ],
                  properties: {
                    className: "qdm",
                  },
                  inlineStyles: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "16px",
                    backgroundColor: "#2d3a43",
                  },
                },
                {
                  type: "component",
                  component: "Div",
                  component_type: "qdm",
                  name: "Div",

                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Icons",
                      component_type: "qdm",
                      name: "Icons",

                      attr: null,
                      properties: {
                        fontIcon: "asl-interpreting",
                        ariaHidden: "true",
                        size: "small",
                      },
                      inlineStyles: {
                        fontSize: "26px",
                        color: "#ffffff",
                      },
                    },
                  ],
                  properties: {
                    className: "qdm",
                  },
                  inlineStyles: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "16px",
                    backgroundColor: "",
                  },
                },
              ],
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "11",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#f2f2f2",
                padding: "0px",
              },
              child: [
                {
                  type: "component",
                  component: "Row",
                  component_type: "qdm",
                  name: "Row",

                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",

                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "Text",
                          component_type: "qdm",
                          name: "Text",

                          attr: null,
                          properties: {
                            name: "Header",
                          },
                          inlineStyles: {
                            fontSize: "24px",
                            fontWeight: "500",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        backgroundColor: "#ffffff",
                        height: "60px",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        padding: "",
                      },
                    },
                  ],
                  properties: {
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    spacing: 2,
                  },
                  inlineStyles: {
                    height: "",
                  },
                },
                {
                  type: "component",
                  component: "Row",
                  component_type: "qdm",
                  name: "Row",

                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",

                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "Card",
                          component_type: "qdm",
                          name: "Card",

                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "CardHeader",
                              component_type: "qdm",
                              name: "CardHeader",

                              attr: null,
                            },
                            {
                              type: "component",
                              component: "CardContent",
                              component_type: "qdm",
                              name: "CardContent",

                              attr: null,
                            },
                          ],
                          properties: {
                            children: "Card",
                          },
                          inlineStyles: {
                            marginBottom: "30px",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: "4",
                        xs: 12,
                        md: "4",
                        sm: 12,
                      },
                      inlineStyles: {
                        padding: "",
                      },
                    },
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",

                      attr: null,
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: "4",
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {},
                      child: [
                        {
                          type: "component",
                          component: "Card",
                          component_type: "qdm",
                          name: "Card",

                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "CardHeader",
                              component_type: "qdm",
                              name: "CardHeader",

                              attr: null,
                            },
                            {
                              type: "component",
                              component: "CardContent",
                              component_type: "qdm",
                              name: "CardContent",

                              attr: null,
                            },
                          ],
                          properties: {
                            children: "Card",
                          },
                          inlineStyles: {
                            marginBottom: "30px",
                          },
                        },
                      ],
                    },
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",

                      attr: null,
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: "4",
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {},
                      child: [
                        {
                          type: "component",
                          component: "Card",
                          component_type: "qdm",
                          name: "Card",

                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "CardHeader",
                              component_type: "qdm",
                              name: "CardHeader",

                              attr: null,
                            },
                            {
                              type: "component",
                              component: "CardContent",
                              component_type: "qdm",
                              name: "CardContent",

                              attr: null,
                            },
                          ],
                          properties: {
                            children: "Card",
                          },
                          inlineStyles: {
                            marginBottom: "30px",
                          },
                        },
                      ],
                    },
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",

                      attr: null,
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: "4",
                        xs: 12,
                        md: "4",
                        sm: 12,
                      },
                      inlineStyles: {},
                      child: [
                        {
                          type: "component",
                          component: "Card",
                          component_type: "qdm",
                          name: "Card",

                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "CardHeader",
                              component_type: "qdm",
                              name: "CardHeader",

                              attr: null,
                            },
                            {
                              type: "component",
                              component: "CardContent",
                              component_type: "qdm",
                              name: "CardContent",

                              attr: null,
                            },
                          ],
                        },
                      ],
                    },
                  ],
                  properties: {
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    spacing: 2,
                  },
                  inlineStyles: {
                    padding: "30px",
                  },
                },
              ],
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            height: "100vh",
          },
        },
      ],
      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        padding: "0px",
        backgroundColor: "#ffffff",
      },
    },
  },
  {
    name: "Form 1",
    type: "component",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-06-02-at-12.05.06-PM.png",
    json: {
      type: "component",
      component: "Form",
      component_type: "qdm",
      name: "Form",

      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",

          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "TextInput",
                  component_type: "qdm",
                  name: "TextInput",

                  properties: {
                    type: "text",
                    name: "text",
                    variant: "outlined",
                    helperTextType: "error",
                    label: "Name",
                    autoFocus: false,
                    autoComplete: "off",
                    search: false,
                    borderColor: "#9b9b9b",
                    elevation: "0",
                    placeholder: "Enter Name",
                    size: "medium",
                  },
                  inlineStyles: {},
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                marginBottom: "20px",
              },
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "TextInput",
                  component_type: "qdm",
                  name: "TextInput",

                  properties: {
                    type: "number",
                    name: "text",
                    variant: "outlined",
                    helperTextType: "error",
                    label: "Age",
                    autoFocus: false,
                    autoComplete: "off",
                    search: false,
                    borderColor: "#9b9b9b",
                    elevation: "0",
                    placeholder: "Enter Age",
                    size: "medium",
                  },
                  inlineStyles: {},
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                marginBottom: "20px",
              },
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "TapSelect",
                  component_type: "qdm",
                  name: "TapSelect",

                  properties: {
                    type: "single",
                    fullWidth: false,
                    selectedBorderColor: "#1890ff",
                    selectedBackgroundColor: "#fff",
                    selectedTextColor: "#1890ff",
                    textSize: "small",
                    iconHeight: 20,
                    iconWidth: 20,
                    textColor: "#000",
                    label: "Gender",
                    options: [
                      {
                        value: "Male",
                        label: "Male",
                      },
                      {
                        value: "Female",
                        label: "Female",
                      },
                      {
                        value: "Others",
                        label: "Others",
                      },
                    ],
                    iconPosition: "left",
                  },
                  inlineStyles: {},
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "6",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                marginBottom: "20px",
              },
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "TextInput",
                  component_type: "qdm",
                  name: "TextInput",

                  properties: {
                    type: "number",
                    name: "Mobile number",
                    variant: "outlined",
                    helperTextType: "error",
                    label: "Mobile Number",
                    autoFocus: false,
                    autoComplete: "off",
                    search: false,
                    borderColor: "#9b9b9b",
                    elevation: "0",
                    placeholder: "Enter mobile number",
                    size: "medium",
                  },
                  inlineStyles: {},
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "6",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                marginBottom: "20px",
              },
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              child: [
                {
                  type: "component",
                  component: "TextInput",
                  component_type: "qdm",
                  name: "TextInput",
                  properties: {
                    type: "text",
                    name: "text",
                    variant: "outlined",
                    helperTextType: "error",
                    label: "Provider Address",
                    autoFocus: false,
                    autoComplete: "off",
                    search: false,
                    borderColor: "#9b9b9b",
                    elevation: "0",
                    placeholder: "Enter Address",
                    size: "medium",
                  },
                  inlineStyles: {},
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                marginBottom: "30px",
              },
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",

              child: [
                {
                  type: "component",
                  component: "Button",
                  component_type: "qdm",
                  name: "Button",

                  properties: {
                    type: "button",
                    variant: "outlined",
                    name: "Save",
                  },
                  inlineStyles: {},
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "flex-start",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                display: "flex",
                justifyContent: "flex-end",
              },
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            padding: "20px",
          },
        },
      ],
    },
  },
];
